import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import {
    clearZoom,
    navigate,
    sendGameMessage,
    sendTypingMessage,
    zoomCard
} from '../../redux/actions';

import PlayerStats from './PlayerStats';
import PlayerRow from './PlayerRow';
import CardZoom from './CardZoom';
import GameChat from './GameChat';
import GameConfigurationModal from './GameConfigurationModal';

import './GameBoard.scss';
import PlayerPBRow from './PlayerPBRow';
import ManualCommands from '../../pages/ManualCommands';
import MovablePanel from './MovablePanel';
import WinLoseSplash from './WinLoseSplash';
import Sidebar from './Sidebar';
import ChampionDefeatSplash from './ChampionDefeatSplash';
import AlertSplash from './AlertSplash';

const placeholderPlayer = {
    cardPiles: {
        discard: [],
        hand: [],
        purged: [],
        deck: [],
        spent: []
    },
    activePlayer: false,
    firstPlayer: false,
    numDeckCards: 0,
    title: null,
    user: null,
    dice: []
};

const GameBoard = () => {
    const dispatch = useDispatch();
    const [showMessages, setShowMessages] = useState(true);
    const [showManualCommands, setShowManualCommands] = useState(false);
    const [showWinSplash, setShowWinSplash] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const currentGame = useSelector((state) => state.lobby.currentGame);
    const cardSize = useSelector((state) => state.account.user.settings.cardSize);
    const cardToZoom = useSelector((state) => state.cards.zoomCard);
    const cards = useSelector((state) => state.cards.cards);
    const optionSettings = useSelector((state) => state.account.user.settings.optionSettings || {});
    const authUser = useSelector((state) => state.auth.user);
    const user = useSelector((state) => state.account.user);

    const onMouseOver = (card) => {
        dispatch(zoomCard(card));
    };

    const onMouseOut = () => {
        dispatch(clearZoom());
    };

    const onCardClick = (card, source) => {
        if (manualMode && source === 'play area') {
            if (!thisPlayer.inspectionCard) {
                dispatch(sendGameMessage('inspectCard', card.uuid));
            } else {
                dispatch(sendGameMessage('closeInspector'));
            }
        }
        // } else {
        dispatch(sendGameMessage('cardClicked', card.uuid));
        // }
    };

    const onCardAltClick = (card) => {
        dispatch(sendGameMessage('cardAltClicked', card.uuid));
    };

    const handleDrawPopupChange = (event) => {
        dispatch(sendGameMessage('showDrawDeck', event.visible));
    };

    const sendChatMessage = (message) => {
        dispatch(sendGameMessage('chat', message));
    };

    const sendPlayerTyping = (arg) => {
        dispatch(sendTypingMessage(arg));
    };

    const onShuffleClick = () => {
        dispatch(sendGameMessage('shuffleDeck'));
    };

    const onPileClick = (source) => {
        dispatch(sendGameMessage('pileClicked', source));
    };

    const onDragDrop = (card, source, target) => {
        dispatch(sendGameMessage('drop', card.uuid, source, target));
    };

    const onCommand = (command, arg, uuid, method) => {
        let commandArg = arg;
        dispatch(sendGameMessage(command, commandArg, uuid, method));
    };

    const onMenuItemClick = (card, menuItem) => {
        dispatch(sendGameMessage('menuItemClick', card.uuid, menuItem));
    };

    const onOptionSettingToggle = (option, value) => {
        dispatch(sendGameMessage('toggleOptionSetting', option, value));
    };

    const onTimerExpired = (uuid) => {
        dispatch(sendGameMessage('menuButton', null, uuid, 'pass'));
    };

    const onMuteClick = () => {
        dispatch(sendGameMessage('toggleMuteSpectators'));
    };

    const onSettingsClick = () => {
        setShowModal(true);
    };

    const onMessagesClick = () => {
        setShowMessages(!showMessages);
    };

    const onManualModeClick = (event) => {
        event.preventDefault();
        dispatch(sendGameMessage('toggleManualMode'));
    };

    const onManualCommandsClick = () => {
        setShowManualCommands(!showManualCommands);
    };

    const onWinSplashCloseClick = () => {
        setShowWinSplash(!showWinSplash);
    };

    const defaultPlayerInfo = (source) => {
        let player = Object.assign({}, placeholderPlayer, source);
        player.cardPiles = Object.assign({}, placeholderPlayer.cardPiles, player.cardPiles);
        player.dice = Object.assign([], placeholderPlayer.dice, player.dice);
        return player;
    };

    const cardProps = {
        onClick: onCardClick,
        onMouseOut,
        onMouseOver,
        size: cardSize
    };

    const showBatlleZone = currentGame.attack && currentGame.attack.battles && !!currentGame.attack.battles.length;

    const renderBoard = (
        thisPlayer,
        otherPlayer,
        compactLayout,
        leftMode,
        cardSize,
        spectating
    ) => {
        return [
            <div key='board-middle' className='board-middle'>
                <>
                    {!compactLayout && (
                        <div className='player-home-row'>
                            <PlayerRow
                                active={otherPlayer.activePlayer}
                                cardSize={cardSize}
                                isMe={false}
                                hand={otherPlayer.cardPiles.hand}
                                leftMode={leftMode}
                                manualMode={currentGame.manualMode}
                                onCardClick={onCardClick}
                                onMouseOut={onMouseOut}
                                onMouseOver={onMouseOver}
                                side='top'
                                dice={otherPlayer.dice}
                                purgedPile={otherPlayer.cardPiles.purged}
                                player={otherPlayer}

                            />
                        </div>
                    )}
                    <div className='player-home-row'>
                        <PlayerPBRow
                            active={otherPlayer.activePlayer}
                            cardSize={cardSize}
                            discard={otherPlayer.cardPiles.discard}
                            drawDeck={otherPlayer.cardPiles.deck}
                            isMe={false}
                            manualMode={currentGame.manualMode}
                            numDeckCards={otherPlayer.numDeckCards}
                            onCardClick={onCardClick}
                            onMouseOver={onMouseOver}
                            onMouseOut={onMouseOut}
                            player={otherPlayer}
                            showDice={compactLayout}
                            showDeckPile={!compactLayout}
                            side='top'
                            spells={otherPlayer.cardPiles.spells}
                            spectating={spectating}
                            champions={otherPlayer.champions}
                        />
                    </div>
                </>

                <div className='board-inner'>
                    <div className='play-area'>
                        {/* this is filler for layout (used to be battlefield) */}
                    </div>
                </div>
                <div className='player-home-row our-side'>
                    <PlayerPBRow
                        active={thisPlayer.activePlayer}
                        cardSize={cardSize}
                        discard={thisPlayer.cardPiles.discard}
                        drawDeck={thisPlayer.cardPiles.deck}
                        isMe={!spectating}
                        manualMode={currentGame.manualMode}
                        numDeckCards={thisPlayer.numDeckCards}
                        onCardClick={onCardClick}
                        onCardAltClick={onCardAltClick}
                        onMouseOver={onMouseOver}
                        onMouseOut={onMouseOut}
                        onMenuItemClick={onMenuItemClick}
                        player={thisPlayer}
                        showDice={spectating && compactLayout}
                        showDeckPile={!(spectating && compactLayout)}
                        side='bottom'
                        spells={thisPlayer.cardPiles.spells}
                        spectating={spectating}
                        onDrawPopupChange={handleDrawPopupChange}
                        onPileClick={onPileClick}
                        onShuffleClick={onShuffleClick}
                        onDragDrop={onDragDrop}
                        champions={thisPlayer.champions}
                    />
                </div>
                <div className='player-home-row our-side'>
                    {!(spectating && compactLayout) && (
                        <PlayerRow
                            active={thisPlayer.activePlayer}
                            cardSize={cardSize}
                            isMe={!spectating}
                            hand={thisPlayer.cardPiles.hand}
                            leftMode={leftMode}
                            manualMode={currentGame.manualMode}
                            onCardClick={onCardClick}
                            onCardAltClick={onCardAltClick}
                            onDragDrop={onDragDrop}
                            onMouseOut={onMouseOut}
                            onMouseOver={onMouseOver}
                            onMenuItemClick={onMenuItemClick}
                            side='bottom'
                            dice={thisPlayer.dice}
                            purgedPile={thisPlayer.cardPiles.purged}
                            player={thisPlayer}

                        />
                    )}
                </div>
            </div>
        ];
    };

    if (Object.values(cards).length === 0 || !currentGame?.started) {
        return (
            <div>Waiting for server...</div>
        );
    }

    if (!authUser) {
        dispatch(navigate('/'));
        return (
            <div>You are not logged in, redirecting...</div>
        );
    }

    let spectating = !currentGame.players[user.username];
    let thisPlayer = currentGame.players[user.username];
    if (!thisPlayer) {
        thisPlayer = Object.values(currentGame.players)[0];
    }

    if (!thisPlayer) {
        return (
            <div>Waiting for game to have players or close...</div>
        );
    }

    let otherPlayer = Object.values(currentGame.players).find((player) => {
        return player.name !== thisPlayer.name;
    });

    // Default any missing information
    thisPlayer = defaultPlayerInfo(thisPlayer);
    otherPlayer = defaultPlayerInfo(otherPlayer);

    let boardClass = classNames('game-board', {
        'select-cursor': thisPlayer && thisPlayer.selectCard
    });

    const showAlertSplash = thisPlayer.promptState.showAlert === 'alert';

    let manualMode = currentGame.manualMode;
    const compactLayout = optionSettings?.compactLayout;
    const leftMode = optionSettings?.leftMode || currentGame.solo || compactLayout;

    return (
        <div className={boardClass}>
            {showModal && (
                <GameConfigurationModal
                    optionSettings={thisPlayer.optionSettings}
                    onOptionSettingToggle={onOptionSettingToggle}
                    onClose={() => setShowModal(false)}
                />
            )}
            <div className='stats-top'>
                <PlayerStats
                    stats={otherPlayer.stats}
                    activePlayer={otherPlayer.activePlayer}
                    compactLayout={compactLayout}
                    firstPlayer={otherPlayer.firstPlayer}
                    champions={otherPlayer.champions}
                    player={otherPlayer}
                    winner={currentGame.winner}
                    onCardClick={onCardClick}
                    onMouseOver={onMouseOver}
                    onMouseOut={onMouseOut}
                    solo={currentGame.solo}
                    leftMode={leftMode}
                    showContextItem={!leftMode}
                    side='top'
                    size={cardSize}
                />
            </div>
            <div className='main-window'>
                {leftMode && (
                    <Sidebar
                        thisPlayer={thisPlayer}
                        onCommand={onCommand}
                        onMouseOver={onMouseOver}
                        onMouseOut={onMouseOut}
                        onTimerExpired={onTimerExpired}
                        onSettingsClick={onSettingsClick}
                        onManualModeClick={onManualModeClick}
                        onManualCommandsClick={onManualCommandsClick}
                        leftMode={leftMode}
                        hideContent={showAlertSplash}
                    />
                )}
                {renderBoard(
                    thisPlayer,
                    otherPlayer,
                    compactLayout,
                    leftMode,
                    cardSize,
                    spectating
                )}
                {thisPlayer.promptState?.showAlert === 'defeat' && (
                    <ChampionDefeatSplash player={thisPlayer} />
                )}
                {showWinSplash && currentGame.winner && (
                    <WinLoseSplash game={currentGame} onCloseClick={onWinSplashCloseClick} />
                )}
                {showAlertSplash && (
                    <AlertSplash
                        thisPlayer={thisPlayer}
                        onCommand={onCommand}
                        onMouseOver={onMouseOver}
                        onMouseOut={onMouseOut}
                        onTimerExpired={onTimerExpired}
                        onCloseClick={() => dispatch(sendGameMessage('closeAlert'))}
                    />
                )}
                {!thisPlayer.inspectionCard && cardToZoom && (
                    <div>
                        <CardZoom
                            cardName={cardToZoom ? cardToZoom.name : null}
                            card={cardToZoom}
                            cardSize={cardSize}
                            left={leftMode}
                        />
                    </div>
                )}
                {showManualCommands && (
                    <MovablePanel
                        title='Manual Commands'
                        name='Manual'
                        onCloseClick={onManualCommandsClick}
                        side='bottom'
                    >
                        <div className='panel-body'>
                            <ManualCommands />
                        </div>
                    </MovablePanel>
                )}
                <div className='right-side'>
                    {!leftMode && (
                        <Sidebar
                            thisPlayer={thisPlayer}
                            onCommand={onCommand}
                            onMouseOver={onMouseOver}
                            onMouseOut={onMouseOut}
                            onTimerExpired={onTimerExpired}
                            onSettingsClick={onSettingsClick}
                            onManualModeClick={onManualModeClick}
                            onManualCommandsClick={onManualCommandsClick}
                            leftMode={leftMode}
                        />
                    )}

                    {showMessages && (
                        <div className='gamechat'>
                            {/* {getOtherPlayerPrompt(otherPlayer)} */}
                            <GameChat
                                key='gamechat'
                                messages={currentGame.messages}
                                onCardMouseOut={onMouseOut}
                                onCardMouseOver={onMouseOver}
                                onMuteClick={onMuteClick}
                                onSendChat={sendChatMessage}
                                onPlayerTyping={sendPlayerTyping}
                                muted={spectating && currentGame.muteSpectators}
                                muteSpectators={currentGame.muteSpectators}
                            />
                        </div>
                    )}
                </div>
            </div>
            <div>
                <PlayerStats
                    activePlayer={thisPlayer.activePlayer}
                    compactLayout={spectating && compactLayout}
                    firstPlayer={thisPlayer.firstPlayer}
                    isMe={!spectating}
                    manualModeEnabled={manualMode}
                    muteSpectators={currentGame.muteSpectators}
                    onDragDrop={onDragDrop}
                    onManualCommandsClick={onManualCommandsClick}
                    onManualModeClick={onManualModeClick}
                    onCardClick={onCardClick}
                    onCardAltClick={onCardAltClick}
                    onMouseOver={onMouseOver}
                    onMouseOut={onMouseOut}
                    onMenuItemClick={onMenuItemClick}
                    onMessagesClick={onMessagesClick}
                    onMuteClick={onMuteClick}
                    onSettingsClick={onSettingsClick}
                    champions={thisPlayer.champions}
                    player={thisPlayer}
                    showControls={!spectating && manualMode}
                    showManualMode={!spectating}
                    showMessages
                    showContextItem={!leftMode}
                    size={cardSize}
                    stats={thisPlayer.stats}
                    winner={currentGame.winner}
                    side='bottom'
                />
            </div>
        </div >
    );
};

PlayerStats.displayName = 'GameBoard';

export default GameBoard;
